const Auth = () => import('@/views/Auth/login')
const Bridge = () => import('@/views/Auth/bridge')

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: [],                  业务逻辑的子页面高亮设置
    module: XXX                  所属于模块
  }
**/

export default [
  {
    path: '/login',
    name: 'login',
    component: Auth,
    hidden: true,
    meta: {
      sort: 0,
      modules: 'auth',
    },
  },
  {
    path: '/bridge',
    name: 'bridge',
    component: Bridge,
    hidden: true,
    meta: {
      sort: 0,
      modules: 'auth',
    },
  },
]
